import { Empty } from "antd";
import Title from "antd/lib/typography/Title";

const EmptyBranch = () => {
  return <Empty description={<Title level={2}>Select Location</Title>} />;
};

export default EmptyBranch;
